/** Arabic comma (U+060C). Arabic lists use it where English uses ",". */
const ARABIC_COMMA = "،";

/**
 * Join labels with the separator the locale actually uses. These lists were
 * hardcoded to "، ", which rendered as "Cash، Wallet" in the English portal.
 *
 * Deliberately not `Intl.ListFormat`: every Arabic variant of it splices in
 * "و" ("and"), which is right for a prose list and wrong for a chip/filter
 * summary.
 */
export function joinLocalized(
  parts: readonly string[],
  locale: string,
): string {
  const separator =
    locale.split("-")[0] === "ar" ? `${ARABIC_COMMA} ` : ", ";
  return parts.filter((part) => part.trim().length > 0).join(separator);
}
